import { CrudService } from '@/services/crudService';

export type LegalSettings = {
  generalConditions: string;
  wayver: string;
  privacyPolicyFull: string;
  cookiesPolicy: string;
};

const defaultLegalSettings: LegalSettings = {
  generalConditions: '<p>Legal information is currently unavailable.</p>',
  wayver: '<p>Legal information is currently unavailable.</p>',
  privacyPolicyFull: '<p>Legal information is currently unavailable.</p>',
  cookiesPolicy: '<p>Legal information is currently unavailable.</p>',
};

let cachedSettings: LegalSettings | null = null;

function normalizeBaseUrl(raw: string | undefined | null): string {
  if (!raw) {
    return '';
  }
  return raw.endsWith('/') ? raw.slice(0, -1) : raw;
}

export async function fetchLegalSettings(): Promise<LegalSettings> {
  if (cachedSettings) {
    return cachedSettings;
  }

  const baseUrl = normalizeBaseUrl(process.env.VUE_APP_MEDKUS_BACKEND_URL);
  if (baseUrl) {
    try {
      const crud = new CrudService({
        baseUrl,
        allowAuth: false,
        handleUnauthorized: false,
      });
      const response = await crud.httpGet('/api/czconfigs/legal-settings', null, undefined, 'json', {
        headers: {
          Accept: 'application/json',
        },
        baseUrl,
      });
      const payload = response && typeof response === 'object'
        ? ((response as { data?: Record<string, unknown> }).data || response)
        : {};
      cachedSettings = {
        generalConditions: (payload as { generalConditions?: string }).generalConditions || defaultLegalSettings.generalConditions,
        wayver: (payload as { wayver?: string }).wayver || defaultLegalSettings.wayver,
        privacyPolicyFull: (payload as { privacyPolicyFull?: string }).privacyPolicyFull || defaultLegalSettings.privacyPolicyFull,
        cookiesPolicy: (payload as { cookiesPolicy?: string }).cookiesPolicy || defaultLegalSettings.cookiesPolicy,
      };
      return cachedSettings;
    } catch (error) {
      void error;
    }
  }

  cachedSettings = { ...defaultLegalSettings };
  return cachedSettings;
}
